import { get, post } from '../client';

export const authApi = {
  login: (email, password) => post('/auth/login', { email, password }),
  forgotPassword: (email) => post('/auth/forgot-password', { email }),
  resetPassword: (email, otp, newPassword) =>
    post('/auth/reset-password', { email, otp, newPassword }),
  refresh: (refreshToken) => post('/auth/refresh', { refreshToken }),
  logout: (refreshToken) => post('/auth/logout', { refreshToken }),
  me: () => get('/auth/me'),
};
